import { useLang } from "@/i18n/LanguageContext";
import { sectionImages } from "@/data/media";
import { Check } from "lucide-react";

const About = () => {
  const { t } = useLang();
  const stats = t("about.stats");
  const bullets = t("about.bullets");

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 border-t border-[#1f1f1f]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Left: image stack */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={sectionImages.furnace}
                alt="Powder coating furnace"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden md:flex bg-[#dc2626] text-white p-6 max-w-[220px]">
              <div>
                <p className="font-display font-black text-4xl leading-none">
                  7,20m
                </p>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase mt-2">
                  Piec lakierniczy
                </p>
              </div>
            </div>
          </div>

          {/* Right: content */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("about.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95] mb-6">
              {t("about.heading")}
            </h2>
            <p className="text-base md:text-lg text-[#a1a1aa] leading-relaxed max-w-2xl mb-10">
              {t("about.lead")}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1f1f1f] mb-10">
              {stats.map((s, i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="bg-[#0a0a0a] p-5 md:p-6"
                >
                  <p className="font-display font-black text-2xl md:text-3xl text-white">
                    {s.value}
                  </p>
                  <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#71717a] mt-2">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>

            {/* Bullets */}
            <ul className="grid sm:grid-cols-2 gap-3">
              {bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-sm text-[#d4d4d8]"
                >
                  <Check className="w-4 h-4 text-[#dc2626] mt-0.5 shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
